import cns from 'classnames';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { Fragment, PureComponent } from 'react';
import { RuntimeContext } from '../../../../common/RuntimeContext';
import VerbMenuItem from '../../../shared/components/VerbMenuItem';
import VerbText from '../../../shared/components/VerbText';
import { SEGMENT_EVENTS } from '../../../shared/Constants';

export default class AnalyticsMenu extends PureComponent {
    static contextType = RuntimeContext;

    handleClick = (eventName) => {
        this.props.handleDropdownClick();
    };

    /**
     *
     * @param {Object} params
     * @param {*} ComponentToRender
     * @param {boolean} params.isMobile
     * @return {XML}
     * @private
     */
    _generateSubMenuDivider = (params) => {
        const { key = '', isMobile } = params;

        const componentProps = {
            className: cns({ 'hidden-sm hidden-md hidden-lg': !isMobile }, 'dropdown-divider')
        };

        if (!isEmpty(key)) {
            componentProps.key = key;
        }

        return <div {...componentProps} />;
    };

    _buildSubMenu = () => {
        const {
            isVerbReportViewer,
            isCompanyReportViewer,
            userCompany,
            renderForMobile,
            history
            // eslint-disable-next-line react/prop-types
        } = this.props;
        const menuItemsToRender = [];

        if (isVerbReportViewer || isCompanyReportViewer) {
            menuItemsToRender.push(
                <VerbMenuItem
                    key={'/measure/reports'}
                    className={'measure-reports'}
                    onClick={() => {
                        history.push(`/admin/measure/reports`);
                        return this.handleClick(SEGMENT_EVENTS.NAV_MEASURE_REPORTS);
                    }}
                >
                    <small className={'navbar-subsection-title'}>
                        <VerbText messageId={'NAVIGATION_DASHBOARDS'} defaultMessage={'ENGAGEMENT DASHBOARD'} />
                    </small>
                </VerbMenuItem>
            );
        }

        if (isVerbReportViewer) {
            menuItemsToRender.push(
                <VerbMenuItem
                    key={'/measure/license-request-report'}
                    className={'measure-license-request-report'}
                    onClick={() => {
                        window.open(`${this.context.pathsWeb.LICENSE_REQUEST_REPORT_URL}`, '_blank');
                    }}
                >
                    <small className={'navbar-subsection-title'}>
                        <VerbText
                            messageId={'NAVIGATION_LICENSE_REQUEST_REPORT'}
                            defaultMessage={'LICENSE REQUEST REPORT'}
                        />
                    </small>
                </VerbMenuItem>
            );
        }

        if (isVerbReportViewer) {
            menuItemsToRender.push(
                this._generateSubMenuDivider({
                    key: 'divider2',
                    isMobile: renderForMobile,
                    className: 'dropdown-divider'
                })
            );
            menuItemsToRender.push(
                <VerbMenuItem
                    key={'/measure/csvdownloads'}
                    className={'measure-csv-downloads'}
                    onClick={() => {
                        history.push('/admin/measure/csvdownloads');
                        return this.handleClick(SEGMENT_EVENTS.NAV_MEASURE_CSV_DOWNLOADS);
                    }}
                >
                    <small className={'navbar-subsection-title'}>
                        <VerbText messageId={'NAVIGATION_CSV_DOWNLOADS'} defaultMessage={'CSV DOWNLOADS'} />
                    </small>
                </VerbMenuItem>
            );
        }

        if (
            isVerbReportViewer &&
            (this.context.pathsWeb.environment === 'demo' || this.context.pathsWeb.environment === 'local')
        ) {
            menuItemsToRender.push(
                <VerbMenuItem
                    key={'/measure/reportsqa'}
                    className={'measure-reports'}
                    onClick={() => {
                        history.push(`/admin/measure/reportsqa`);
                        return this.handleClick(SEGMENT_EVENTS.NAV_MEASURE_REPORTS);
                    }}
                >
                    <small className={'navbar-subsection-title'}>
                        <VerbText
                            messageId={'NAVIGATION_DASHBOARDS_QA'}
                            defaultMessage={'ENGAGEMENT QA Company Admin'}
                        />
                    </small>
                </VerbMenuItem>
            );
        }

        return menuItemsToRender;
    };

    render() {
        return <Fragment>{this._buildSubMenu()}</Fragment>;
    }
}
AnalyticsMenu.propTypes = {
    isVerbReportViewer: PropTypes.bool,
    isVerbAdmin: PropTypes.bool,
    isCompanyAdmin: PropTypes.bool,
    userCompany: PropTypes.object,
    isCompanyReportViewer: PropTypes.bool,
    handleDropdownClick: PropTypes.func,
    renderForMobile: PropTypes.bool,
    history: PropTypes.object.isRequired
};
